/**
 * Gets the state containing all job listings.
 * @param {Object} state The application state
 * @return {Map} The state for all job listings.
 */
export default (state) => state.allJobListings;
